import Vue from 'vue'
import Router from 'vue-router'

import Welcome from '@/components/pages/Welcome'
// import CovidMap from '@/components/pages/CovidMap'
import Map from '@/components/pages/Map'
import MapTable from '@/components/pages/MapTable'
import CompareAttributes from '@/components/pages/CompareAttributes'
import CompareCountriesRegions from '@/components/pages/CompareCountriesRegions'
import CountriesRegionsProfile from '@/components/pages/CountriesRegionsProfile'
import NotFound from '@/components/pages/NotFound'
// import Covid19PDF from '@/components/pdf/Covid19PDF'

Vue.use(Router)

let router = new Router({
  base: '/gsod-indices/',
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/welcome'
    },
    {
      path: '/world-map',
      redirect: '/democracy-indices'
    },
    {
      path: '/indices/world-map ',
      redirect: '/democracy-indices'
    },
    {
      path: '/covid-19-monitor',
      redirect: '/covid19globalmonitor'
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: Welcome
    },
    {
      path: '/covid19globalmonitor',
      name: 'covid-19-monitor',
      component: Map,
      props: { covidEnable: true }
    },
    {
      path: '/democracy-indices',
      name: 'democracy-indices',
      component: Map,
      props: { covidEnable: false }
    },
    {
      path: '/world-map',
      name: 'world-map',
      component: Map
    },
    {
      path: '/world-map-table',
      name: 'world-map-table',
      component: MapTable
    },
    {
      path: '/compare-attributes',
      name: 'compare-attributes',
      component: CompareAttributes
    },
    {
      path: '/compare-countries-regions',
      name: 'compare-countries-regions',
      component: CompareCountriesRegions
    },
    {
      path: '/countries-regions-profile',
      name: 'countries-regions-profile',
      component: CountriesRegionsProfile
    },
    {
      path: '*',
      component: NotFound
    }
    // {
    //   path: '/pdf/covid19/profile',
    //   name: 'COVID19 profile PDF',
    //   component: Covid19PDF
    // }
  ]
})

export default router

if (location.hash) {
  let democracyUrl = location.origin + '/gsod-indices/democracy-indices'
  let covidUrl = location.origin + '/gsod-indices/covid19globalmonitor'
  location.replace(location.hash.replace('#/indices/world-map', democracyUrl))
  location.replace(location.hash.replace('#/indices/countries-regions-profile?rsc=%5B625%5D&covid19=1', democracyUrl))
  location.replace(location.hash.replace('#/covid-19-monitor', covidUrl))
}



// WEBPACK FOOTER //
// ./src/router/index.js